import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorInfoContainer } from './Style';
const ErrorInfo: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ErrorInfoContainer>
      <div>
        <h1>Oops!</h1>
      </div>
      <div>
        <h3>{t('Something went wrong')}</h3>
      </div>
    </ErrorInfoContainer>
  );
};

export default ErrorInfo;
